<template>
	<div
		v-for="(guest, i) in guestNumber"
		:key="guest"
		class="d-flex align-center justify-space-between"
	>
		<div class="d-flex gap-2 align-center">
			<Avatar :src="guestAvatar" height="32px" width="32px" />
			<div class="text-neutral-600 text-body-m">
				<p :class="isXS ? 'email-mobile' : ''">
					{{ $t('common.traveler.label') }} {{ i + 1 + guestStart }}
				</p>
			</div>
		</div>
		<div class="d-flex gap-4 align-center">
			<PButton type="text" color="neutral" size="sm" @click="$emit('invite')">
				{{ $t('common.action.invite') }}
			</PButton>
			<div>
				<Dropdown placement="end">
					<template #trigger="{ toggle }">
						<PButton type="text" color="neutral" icon="more" only-icon @click="toggle" />
					</template>
					<template #default="{ close }">
						<MenuList>
							<MenuItem
								icon="trash"
								class="text-error-400"
								:name="$t('web.trip.invite.actions.remove_from_Trip')"
								@click="($emit('remove'), close())"
							/>
						</MenuList>
					</template>
				</Dropdown>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import guestAvatar from '~/assets/guest-avatar.png'

	interface Props {
		guestNumber: number
		guestStart: number
		isXS: boolean
	}

	defineProps<Props>()
	defineEmits(['remove', 'invite'])
</script>

<style scoped lang="scss"></style>
